import { defAlias, defBaseUnit, defSimpleUnit } from '../registry';

export const carbonUnits = [
  defBaseUnit('kgco2e'),
  defSimpleUnit('tonneco2e', 'kgco2e', 1e3),
  defSimpleUnit('kilotonneco2e', 'kgco2e', 1e6),
  defSimpleUnit('megatonneco2e', 'kgco2e', 1e9),
  defSimpleUnit('gigatonneco2e', 'kgco2e', 1e12),

  // DO NOT USE THESE - they use ton when they mean tonne
  defSimpleUnit('tonco2e', 'kgco2e', 1e3),
  defSimpleUnit('kilotonco2e', 'kgco2e', 1e6),
  defSimpleUnit('megatonco2e', 'kgco2e', 1e9),
  defSimpleUnit('gigatonco2e', 'kgco2e', 1e12),
];

defAlias('kilogram[co2e]', 'kgco2e');
defAlias('kg_co2e', 'kgco2e');
